module.exports = __webpack_public_path__ + "img/assistantIcon.11a099c1.svg";